module.exports = __webpack_public_path__ + "img/food-22.e93d81dc.jpg";